export default {
  'area-list': ['area_management']
}
